
function hdr_cd_init_modal() {
   if (!document.body.classList.contains("template-product")) return;
   //select all the needed classes
  const closeBtn = document.getElementById("hdr_cd_pdesc_close");
  const modal = document.getElementById("hdr_cd_modal_pdesc");
  const btnDesc = document.querySelector(".hdr_cd_product_desc");
  const btnVid = document.querySelector(".hdr_cd_show_video");
  //target the clas in the product template.
  const tempDesc = document.querySelector(".hdr_cd_desc_title");
  //target the title to use in the reference of the video using url

  btnDesc.addEventListener("click", () => {
    modal.classList.add("active");
    document.body.style.overflow = "hidden";
    tempDesc.style.display = "block";
  });

  closeBtn.addEventListener("click", () => {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  });
  }

document.addEventListener("DOMContentLoaded", hdr_cd_init_modal);